module.exports = __webpack_public_path__ + "media/components/assets/banner-97400f269c48575998f62275279941f8.png";